const ClientHomeIcon = ({ fillColor = '#000' }: { fillColor: string }) => {
  return (
    <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.75 10.0701C3.75 9.05183 3.75 8.54267 3.95585 8.09512C4.16169 7.64756 4.54827 7.31621 5.32144 6.65349L6.07144 6.01064C7.46893 4.81279 8.16767 4.21387 9 4.21387C9.83233 4.21387 10.5311 4.81279 11.9286 6.01064L12.6786 6.65349C13.4517 7.31621 13.8383 7.64756 14.0442 8.09512C14.25 8.54267 14.25 9.05183 14.25 10.0701V13.2504C14.25 14.6647 14.25 15.3718 13.8107 15.8111C13.3713 16.2504 12.6642 16.2504 11.25 16.2504H6.75C5.33579 16.2504 4.62868 16.2504 4.18934 15.8111C3.75 15.3718 3.75 14.6647 3.75 13.2504V10.0701Z"
        stroke={fillColor}
        strokeWidth="0.75"
      />
      <path
        d="M10.875 16.25V12.5C10.875 12.0858 10.5392 11.75 10.125 11.75H7.875C7.46079 11.75 7.125 12.0858 7.125 12.5V16.25"
        stroke={fillColor}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ClientHomeIcon;
